import React, { useEffect, useMemo, useState } from 'react';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import PriceRangeSlider from '../../../../../../common/atoms/PriceRangeSlider';
import { getSessionStorage, setSessionStorage } from '../../../../../../../utils';
import StyledPriceRangeSliderWrapper from '../styles/PriceFilter.styles';
import { checkMaxMinPriceRange } from '../../../../ProductListing/molecules/ProductFilter/productFilterHelper';
import {
  getAllAppliedFiltersCount,
  getAppliedFiltersArray,
  getAppliedPriceFilter,
  priceRangeNumFormatter,
} from '../../../utils';

const PriceFilter = ({
  filterMaps,
  priceFilterFLag,
  tabPriceRange,
  appliedFilters,
  handleClick,
  priceOptions,
}) => {
  const hasMounted = useHasMounted();
  const priceMinInitial = 'pMinInitial';
  const priceMaxInitial = 'pMaxInitial';
  const { newPriceRange } = filterMaps;

  const { min: minPrice, max: maxPrice } = useMemo(
    () => getAppliedPriceFilter(appliedFilters, priceOptions) || {},
    [appliedFilters]
  );

  const [priceFlag, setPriceFlag] = useState(false);
  const [minInitial, setMinInitial] = useState(priceOptions?.pMinInitial);
  const [maxInitial, setMaxInitial] = useState(priceOptions?.pMaxInitial);
  const [initialRange, setInitialRange] = useState(false);
  const [checkAppliedRange, setCheckAppliedRange] = useState(false);
  const [minSelectedVal, setMinVal] = useState(newPriceRange?.min);
  const [maxSelectedVal, setMaxVal] = useState(newPriceRange?.max);

  let appliedPriceRange = {};

  getAppliedFiltersArray(appliedFilters)?.forEach((val) => {
    appliedPriceRange = { ...val };
  });

  const updatePriceRange = (min, max) => {
    if (min !== null && max !== null) {
      const newMin = priceRangeNumFormatter(min);
      const newMax = priceRangeNumFormatter(max);
      setMinVal(newMin);
      setMaxVal(newMax);
    } else {
      setMinVal(min);
      setMaxVal(max);
    }
  };

  useEffect(() => {
    const pMinInitial = getSessionStorage(priceMinInitial);
    const pMaxInitial = getSessionStorage(priceMaxInitial);
    if (getAllAppliedFiltersCount(appliedFilters) === 0) {
      setSessionStorage({ key: priceMinInitial, value: newPriceRange?.min });
      setSessionStorage({ key: priceMaxInitial, value: newPriceRange?.max });
      setMinInitial(newPriceRange?.min);
      setMaxInitial(newPriceRange?.max);
      setCheckAppliedRange(false);
    }
    if ((!minInitial && !maxInitial) || !initialRange) {
      if (
        (!pMinInitial && !pMaxInitial) ||
        (pMinInitial === 'undefined' && pMaxInitial === 'undefined') ||
        (pMinInitial === 'null' && pMaxInitial === 'null')
      ) {
        setSessionStorage({ key: priceMinInitial, value: newPriceRange?.min });
        setSessionStorage({ key: priceMaxInitial, value: newPriceRange?.max });
        setMinInitial(newPriceRange?.min);
        setMaxInitial(newPriceRange?.max);
        setCheckAppliedRange(false);
      } else {
        setMinInitial(parseFloat(pMinInitial));
        setMaxInitial(parseFloat(pMaxInitial));
        setCheckAppliedRange(true);
      }
    }
    if (!initialRange) {
      setInitialRange(true);
    }
  }, [newPriceRange, priceFlag, priceFilterFLag, tabPriceRange]);

  return (
    checkMaxMinPriceRange(newPriceRange) && (
      <StyledPriceRangeSliderWrapper>
        <PriceRangeSlider
          min={hasMounted && minInitial}
          max={hasMounted && maxInitial}
          minRange={0.01}
          initialTrackWidth={343}
          priceFlag={priceFlag}
          setPriceFlag={setPriceFlag}
          checkAppliedRange={checkAppliedRange}
          setCheckAppliedRange={setCheckAppliedRange}
          onChange={({ min, max }) => updatePriceRange(min, max)}
          appliedPriceRange={appliedPriceRange}
          onDragEnd={(e) => {
            e.preventDefault();
            handleClick('min_offer_price', `${minSelectedVal} TO ${maxSelectedVal}`);
          }}
          hideTooltip
          redesign
          from="quick filters"
          dynamicMin={minPrice}
          dynamicMax={maxPrice}
        />
      </StyledPriceRangeSliderWrapper>
    )
  );
};

export default PriceFilter;
